import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { ConfigCatProvider } from 'configcat-react';
import settings from '../../settings';
import { SidebarProvider } from '../components/Sidebar';
import { AppSidebar } from './AppSidebar';
const CONFIGCAT_SDK_KEY = settings.configCatSDKKey;
// Create a client
const queryClient = new QueryClient();
const Layout = ({ children }) => {
    return (_jsx("div", { id: "coms-ui-module-root", className: "flex flex-col min-h-screen h-full", children: _jsx(ConfigCatProvider, { sdkKey: CONFIGCAT_SDK_KEY, children: _jsx(QueryClientProvider, { client: queryClient, children: _jsx("div", { className: "w-full ", children: _jsxs(SidebarProvider, { children: [_jsx(AppSidebar, {}), _jsx("main", { className: "flex flex-col flex-1 w-[calc(100%-16rem)] relative", id: "main-section", children: children })] }) }) }) }) }));
};
export default Layout;
